enum RedirectAction {
  CANCEL = 'cancel',
  RESCHEDULE = 'reschedule',
  RESERVATION = 'reservation',
  SCHEDULE = 'schedule',
  SETTINGS_RESOURCE_BLOCK_SCHEDULING = 'settings-resource-block-scheduling',
  SETTINGS_RESOURCE_AVAILABILITY_CALENDAR = 'settings-resource-availability-calendar',
  SHOP_RESOURCES_BLOCK_SCHEDULING = 'shop-resources-block-scheduling',
}

export { RedirectAction }
